import PropTypes from 'prop-types';

import { useMessage } from '@zenbusiness/application-commons-intl';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './MenuItem.style';

function UserMenuItem({
  divider,
  icon: Icon,
  labelId,
  messageValues,
  ...delegated
}) {
  const label = useMessage(labelId, messageValues);

  return (
    <Styled.Root divider={divider}>
      <Styled.Link
        clickstreamProps={{
          elementName: 'user_menu_option',
          elementText: label
        }}
        {...delegated}
      >
        <Icon color="text.secondary" />
        <Text component="span" truncate>{label}</Text>
      </Styled.Link>
    </Styled.Root>
  );
}

UserMenuItem.propTypes = {
  divider: PropTypes.oneOf(['top', 'bottom']),
  icon: PropTypes.elementType.isRequired,
  labelId: PropTypes.string.isRequired,
  messageValues: PropTypes.shape({})
};

export default UserMenuItem;
